
import { Component, Vue } from 'vue-property-decorator';
import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '@/services/QA/scoreType/interfaces';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'scoreTypeRepository',
  ],
})
export default class AllScoreTypes extends Vue {
  private readonly scoreTypeRepository: ScoreTypeRepositoryInterface;

  private loading: boolean = true;
  private scoreTypes: ScoreTypeInterface[] = [];

  private search: string = '';
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.scoreTypes = await this.scoreTypeRepository.getAllScoreTypes();
    this.loading = false;
  }

  private async createScoreType(): Promise<void> {
    await this.$router.push({ name: 'score_type_create' });
  }

  private async editScoreType(scoreTypeId: number): Promise<void> {
    await this.$router.push({ name: 'score_type_update', params: { scoreTypeId: String(scoreTypeId) } });
  }
}
